import { createSlice } from "@reduxjs/toolkit";

export const renderTypeSlice = createSlice({
    name: 'rendertype',
    initialState: {
        value: "all"
    },
    reducers: {
        setRenderType: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setRenderType } = renderTypeSlice.actions;

export const getRenderType = (state) => state.rendertype.value;

export default renderTypeSlice.reducer;